import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const toUtcDate = (date, timezoneId) =>
  dayjs.tz(dayjs(date).format("YYYY-MM-DD"), timezoneId).utc().format();

// Shared date rules for both assignment forms. Optional training has no due
// date: it is never flexible and never sends an end date or relative days,
// even when the admin filled those fields before switching to Optional.
const buildAssignmentDates = (values) => {
  const isOptional = values?.is_optional === true;
  const isDateFlexible = !isOptional && (values?.is_flexible_date || false);

  if (isDateFlexible) {
    return {
      isOptional,
      isDateFlexible,
      startDate: null,
      endDate: null,
      relativeEndInDays: values?.relative_end_days || 0,
    };
  }

  const timezoneId = values?.timezone?.id;
  return {
    isOptional,
    isDateFlexible,
    startDate: toUtcDate(values?.start_date, timezoneId),
    endDate:
      (!isOptional &&
        values?.end_date &&
        toUtcDate(values?.end_date, timezoneId)) ||
      null,
    relativeEndInDays: isOptional ? null : values?.relative_end_days || 0,
  };
};

export const buildPathwayAssignmentPayload = (values) => {
  const { isOptional, isDateFlexible, startDate, endDate, relativeEndInDays } =
    buildAssignmentDates(values);

  // Only program-completion rules can switch re-enrolment off; the switch is
  // on by default, so a missing value means true. Every other assignment
  // sends true (the API stores true for them anyway).
  const reenrolIfCompleted =
    values?.subject_to === 3 ? values?.reenrol_if_completed !== false : true;

  const toAssignment = (subjectId) => ({
    timezone: values?.timezone?.id || null,
    isDateFlexible,
    subjectId,
    subjectType: values?.subject_to,
    startDate,
    endDate,
    relativeEndInDays,
    isOptional,
    reenrolIfCompleted,
  });

  if (values?.subject_to !== 1) {
    return { assignments: [toAssignment(values?.program?.id)] };
  }
  return {
    assignments: (values?.audience || []).map((item) => toAssignment(item.id)),
  };
};

export const buildAudienceAssignmentPayload = (values) => {
  const { isOptional, isDateFlexible, startDate, endDate, relativeEndInDays } =
    buildAssignmentDates(values);

  return {
    timezone: values?.timezone?.id || null,
    isDateFlexible,
    // The API property really is spelled LearingPathwayId.
    learingPathwayId: values?.learning_program?.id,
    startDate,
    endDate,
    relativeEndInDays,
    isOptional,
  };
};
